import { clsx } from 'clsx'
import { FC, useState } from 'react'
import { useAuthContext } from '../../context/AuthContext'
import { SidebarLink } from './sidebar-link/sidebar-link'
import { SidebarLogo } from './sidebar-logo/sidebar-logo'
import { SidebarToggle } from './sidebar-toggle/sidebar-toggle'
import styles from './sidebar.module.css'

export const Sidebar: FC = () => {
	const [expanded, setExpanded] = useState(true)
	const toggle = () => {
		setExpanded(!expanded)
	}

	const { userRole } = useAuthContext()

	const isAdmin = userRole !== 'usr'

	return (
		<div
			id='sidebar'
			className={clsx(styles.sidebar, expanded ? styles.expanded : '')}
		>
			<SidebarLogo />

			<SidebarToggle onClick={toggle} expanded={expanded} />
			<div className={styles.sidebar__content}>
				<SidebarLink icon='device' url='/device' label='Устройства' />

				<SidebarLink icon='manual' url='/manual' label='Ручной ввод' />

				<SidebarLink icon='balance' url='/balance' label='Баланс' />

				<SidebarLink icon='consumption' url='/consumption' label='Показания' />

				<SidebarLink icon='vt' url='/vti' label='ВТИ' />

				<SidebarLink icon='export' url='/export' label='Экспорт' />

				<SidebarLink icon='report' url='/report' label='Отчеты' />

				<SidebarLink icon='graph' url='/graph' label='Графики' />

				{isAdmin && (
					<SidebarLink icon='planner' url='/planner' label='Задачи' />
				)}
				{isAdmin && (
					<SidebarLink icon='operator' url='/operator' label='Операторы' />
				)}
				{<SidebarLink icon='log' url='/log' label='Журнал' />}

				<div className={styles.sidebar__footer}>
					{isAdmin && (
						<SidebarLink icon='settings' url='/config' label='Настройки' />
					)}
					<SidebarLink icon='help' url='/help' label='Справка' />
				</div>
			</div>
		</div>
	)
}
